/**
 * U153 ↔ module entry flags (etalon 1.83 contract).
 *
 * Hub sets the flag when opening a route; the module's canonical back-handler
 * at its root consumes the flag and returns to Create Request Hub.
 *
 * Etalon: `window.__U153_EDITORIAL_FROM_HUB__ = true` then `R514.open.home()`.
 * Gap closed here: paired consume + returnToHub (etalon had the flag write only).
 */

export const U153_EDITORIAL_FROM_HUB = '__U153_EDITORIAL_FROM_HUB__' as const;
export const U153_AUTHOR_FROM_HUB = '__U153_AUTHOR_FROM_HUB__' as const;
export const U153_CONTENT_FROM_HUB = '__U153_CONTENT_FROM_HUB__' as const;

type HubFlagWindow = Window &
  Partial<
    Record<
      | typeof U153_EDITORIAL_FROM_HUB
      | typeof U153_AUTHOR_FROM_HUB
      | typeof U153_CONTENT_FROM_HUB,
      boolean
    >
  >;

function hubWindow(): HubFlagWindow | null {
  if (typeof window === 'undefined') return null;
  return window as HubFlagWindow;
}

export function markEditorialOpenedFromHub(): void {
  const w = hubWindow();
  if (w) w[U153_EDITORIAL_FROM_HUB] = true;
}

export function isEditorialOpenedFromHub(): boolean {
  const w = hubWindow();
  return Boolean(w?.[U153_EDITORIAL_FROM_HUB]);
}

/** Consume hub-entry flag (returns whether Editorial was opened from Create Request Hub). */
export function consumeEditorialOpenedFromHub(): boolean {
  const w = hubWindow();
  if (!w) return false;
  const flagged = Boolean(w[U153_EDITORIAL_FROM_HUB]);
  if (flagged) {
    delete w[U153_EDITORIAL_FROM_HUB];
  }
  return flagged;
}

export function markAuthorOpenedFromHub(): void {
  const w = hubWindow();
  if (w) w[U153_AUTHOR_FROM_HUB] = true;
}

export function isAuthorOpenedFromHub(): boolean {
  const w = hubWindow();
  return Boolean(w?.[U153_AUTHOR_FROM_HUB]);
}

export function consumeAuthorOpenedFromHub(): boolean {
  const w = hubWindow();
  if (!w) return false;
  const flagged = Boolean(w[U153_AUTHOR_FROM_HUB]);
  if (flagged) {
    delete w[U153_AUTHOR_FROM_HUB];
  }
  return flagged;
}

export function markContentOpenedFromHub(): void {
  const w = hubWindow();
  if (w) w[U153_CONTENT_FROM_HUB] = true;
}

export function isContentOpenedFromHub(): boolean {
  const w = hubWindow();
  return Boolean(w?.[U153_CONTENT_FROM_HUB]);
}

export function consumeContentOpenedFromHub(): boolean {
  const w = hubWindow();
  if (!w) return false;
  const flagged = Boolean(w[U153_CONTENT_FROM_HUB]);
  if (flagged) {
    delete w[U153_CONTENT_FROM_HUB];
  }
  return flagged;
}
